import React, { useMemo, memo } from 'react';
import WarningIcon from '@mui/icons-material/Warning';
import { Box, Typography } from '@mui/material';
import useAuth from '../hooks/useAuth';

const InvoiceAlert = () => {
  const { user } = useAuth();

  const unpaidInvoiceDueDate = user?.unpaid_invoice_due_date;

  const alertMessage = useMemo(() => {
    if (!unpaidInvoiceDueDate) return null;

    const now = new Date();
    const dueDate = new Date(unpaidInvoiceDueDate);
    const diffDays = Math.ceil((now - dueDate) / (1000 * 60 * 60 * 24));

    if (diffDays > 14) {
      return {
        text: (
          <Box display="flex" justifyContent="center" alignItems="center" gap="8px" sx={{ color: '#721c24' }}>
            <WarningIcon sx={{ color: '#721c24', fontSize: '24px', flexShrink: 0 }} />
            <Typography variant="body1" sx={{ color: '#721c24' }}>
              Kära kund. Ni har obetalda fakturor, därför har ni förlorat tillgången till era
              kundförfrågningar. Betala dessa omgående, se fakturorna{' '}
              <a href="/client/invoices" style={{ textDecoration: 'underline', color: 'inherit' }}>här</a>.
            </Typography>
          </Box>
        ),
        backgroundColor: '#f8d7da',
        color: '#721c24',
      };
    }
    if (diffDays > 7) {
      return {
        text: (
          <Box display="flex" justifyContent="center" alignItems="center" gap="8px" sx={{ color: '#856404' }}>
            <WarningIcon sx={{ color: '#856404', fontSize: '24px', flexShrink: 0 }} />
            <Typography variant="body1" sx={{ color: '#856404' }}>
              Ni har obetalda fakturor. Vänligen betala för att undvika förlora tillgång till era kundförfrågningar.
              Se fakturorna{' '}
              <a href="/client/invoices" style={{ textDecoration: 'underline', color: 'inherit' }}>här</a>.
            </Typography>
          </Box>
        ),
        backgroundColor: '#ffe6cc',
        color: '#856404',
      };
    }

    return null;
  }, [unpaidInvoiceDueDate]);

  if (!alertMessage) return null;

  return (
    <div
      style={{
        backgroundColor: alertMessage.backgroundColor,
        padding: '10px',
        borderRadius: '5px',
        color: alertMessage.color,
        fontWeight: 'bold',
        textAlign: 'center',
      }}>
      {alertMessage.text}
    </div>
  );
};

export default memo(InvoiceAlert);
